import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTransformData = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 36,
	height: 32,
	viewBox: "0 0 36 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M34.8987 13.271H21.5163L14.0945 1.20055C14.0176 1.0759 13.8828 1 13.7375 1H13.7333C13.5867 1.00127 13.4514 1.08014 13.3763 1.20776L1.05892 22.1657C0.981641 22.2967 0.980381 22.4595 1.05514 22.5918C1.1299 22.7245 1.26934 22.8059 1.42012 22.8059H17.2688V31.0688C17.2688 31.3029 17.457 31.4928 17.6888 31.4928H34.8987C35.1306 31.4928 35.3187 31.3029 35.3187 31.0688V13.695C35.3187 13.4609 35.1306 13.271 34.8987 13.271ZM17.2692 13.695V21.9579H2.15764L13.7459 2.24105L20.5276 13.271H17.6888C17.457 13.271 17.2692 13.4609 17.2692 13.695ZM34.4787 30.6452H18.1092V14.119H34.4792L34.4787 30.6452Z",
		stroke: "currentColor"
	})
});
export default SvgTransformData;
